import { gql } from "@apollo/client";

export const INTERVIEW_PLAN_ITEM_FRAGMENT = gql`
  fragment InterviewPlanItemFragment on InterviewPlanItem {
    id
    title
    description
    position
  }
`;

export const INTERVIEW_PLAN_FRAGMENT = gql`
  fragment InterviewPlanFragment on InterviewPlan {
    id
    items {
      ...InterviewPlanItemFragment
    }
  }

  ${INTERVIEW_PLAN_ITEM_FRAGMENT}
`;
